import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Table,
  Stack,
  Pagination,
  styled,
  Avatar,
  Chip,
  TextField,
  Button,
  CircularProgress,
  Checkbox,
  Snackbar,
  Alert,
  IconButton,
  Tooltip,
  Slider,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import MicIcon from "@mui/icons-material/Mic";
import ForumIcon from "@mui/icons-material/Forum";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import Header from "../../../components/header";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../components/AnimatedLoader";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import FormattedDate from "../../../components/FormattedDate";
import {
  convertTimeToMinutes,
  convertCallDuration,
  getFirstLetter,
  formatTime,
} from "../../../utils/common";
import dialerIcon from "../../../assets/table_call_icon.svg";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import NewFilter from "../../../components/NewFilter";
import NoData from "../../../components/NoData";
import CommonFilter from "../../../components/CommonFilter";
import { jwtDecode } from "jwt-decode";
import { Category } from "@mui/icons-material";
import KiwiElevenLabsPanel from "./KiwiElevenLabsPanel";


const LANGUAGE_MAP = {
  "hi-IN": "Hindi",
  "ur-IN": "Urdu",
  "gu-IN": "Gujarati",
  "bn-IN": "Bengali",
  "ml-IN": "Malayalam",
  "ta-IN": "Tamil",
  "te-IN": "Telugu",
  "mr-IN": "Marathi",
  "kn-IN": "Kannada",
  "pa-IN": "Punjabi",
  "en-IN": "English (Indian)",
  "or-IN": "Odia",
  "as-IN": "Assamese",
};

const getRandomAccentColor = () => {
  const colors = ["#10B981", "#6366F1", "#F59E0B", "#3B82F6", "#EC4899"];
  return colors[Math.floor(Math.random() * colors.length)];
};


const TableHeading = styled(TableCell)({
  textTransform: "uppercase",
  fontWeight: 550,
  color: "#6b7280",
  fontSize: "0.7rem",
  backgroundColor: "#f9fafb",
  whiteSpace: "nowrap",
});

const AudioTable = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const isMPokket = decodedToken?.companyName === "mPokket";
  const isVxpressNmc = decodedToken?.companyName === "vxpressnmc";
  const isKiwiCompany = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2";
  const isNipponCompany = decodedToken?.companyId === "69fdafaff0596b391f8be07b";
  const audioPath = process.env.REACT_APP_NIPPON_CONVOZE_AUDIO_PATH;
  const hideReportColumn = false; // decodedToken?.userRole === "BranchManager";
  const isCurator = decodedToken?.userRole === "Curator";
  const isReportGated = ["Manager", "Admin", "QualityAnalyst"].includes(decodedToken?.userRole);
  const [playingId, setPlayingId] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const audioRef = useRef(null);
  const [data, setData] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [paginationData, setPaginationData] = useState({});
  const [payloadData, setPayloadData] = useState();
  const [exportData, setExportData] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDownloadIds, setSelectedDownloadIds] = useState([]);
  const [isDownloadingKiwi, setIsDownloadingKiwi] = useState(false);
  const [downloadingRowId, setDownloadingRowId] = useState(null);
  const [isUpdatingQA, setIsUpdatingQA] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [reprocessMenu, setReprocessMenu] = useState({ anchorEl: null, row: null });
  const [reprocessingRowId, setReprocessingRowId] = useState(null);
  console.log(exportData, "exportData");

  const location = useLocation();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPage(1); // reset pagination on new search
    }, 500); // debounce delay (400-600ms is ideal)

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);



  const isFilter = {
    date: true,
    filter: true,
    callScore:
      ["67e560a6ae2e0d3f96b5eb08", "67e560a6ae2e0d3f96b5eb09"].includes(decodedToken?.companyId) ? true : false,
  };

  useEffect(() => {
    fetchAudioDetails();
  }, [page, payloadData, debouncedSearch]);

  useEffect(() => {
    fetchAgentCampaignDetails();
  }, []);

  const COMPANY_DATE_FILTERS = {
    "67e560a6ae2e0d3f96b5eb09": {
      startDate: "2026-04-03",
      endDate: "2026-04-05"
    },
    "69ba88379b1aea31bda6224e": {
      startDate: "2026-03-18",
      endDate: "2026-03-18",
    },
    "67e560a6ae2e0d3f96b5eb08": {
      startDate: "2026-06-05",
      endDate: "2026-06-08",
    },
  };

  const getDateRangeByCompany = () => {
    // Build "YYYY-MM-DD" from the browser's LOCAL calendar date, not via
    // toISOString() - that converts to UTC first, so for any timezone ahead
    // of UTC (e.g. IST, UTC+5:30) local midnight on the 1st of the month
    // becomes 18:30 the PREVIOUS day in UTC, silently shifting the default
    // "this month" range (and its first day) back by one calendar day.
    const toLocalDateStr = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const today = new Date();
    const todayStr = toLocalDateStr(today);
    const firstOfMonthStr = toLocalDateStr(new Date(today.getFullYear(), today.getMonth(), 1));
    const companyId = decodedToken?.companyId;

    const companyDateConfig = COMPANY_DATE_FILTERS[companyId];

    if (companyDateConfig) {
      return {
        startDate: companyDateConfig.startDate,
        endDate: companyDateConfig.endDate,
      };
    }

    return {
      startDate: payloadData?.filters?.startDate || firstOfMonthStr,
      endDate: payloadData?.filters?.endDate || todayStr,
    };
  };

  const fetchAudioDetails = async () => {
    const { startDate, endDate } = getDateRangeByCompany();
    // const today = new Date();
    // const todayStr = today?.toISOString().split("T")[0];
    // const isLockedCompany =
    //   decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb09";

    // const fixedDateStartDate = "2026-02-01";
    // const fixedDateEndDate = "2026-02-28";

    const payload = {
      // startDate: payloadData?.filters?.startDate
      //   ? payloadData?.filters?.startDate
      //   : today?.toISOString().split("T")[0],
      // endDate: payloadData?.filters?.endDate
      //   ? payloadData?.filters?.endDate
      //   : today?.toISOString().split("T")[0],
      // startDate: isLockedCompany ? fixedDateStartDate : payloadData?.filters?.startDate || todayStr,
      // endDate: isLockedCompany ? fixedDateEndDate : payloadData?.filters?.endDate || todayStr,
      startDate,
      endDate,
      agentName:
        decodedToken?.userRole === "BranchManager"
          ? [decodedToken?.userName]
          : payloadData?.filters?.agents?.length > 0
          ? payloadData?.filters?.agents
          : [],
      branchManagerName:
        payloadData?.filters?.branchManagers?.length > 0
          ? payloadData?.filters?.branchManagers
          : [],
      sentiment:
        payloadData?.filters?.sentiment?.length > 0
          ? payloadData?.filters?.sentiment
          : [],
      status: payloadData?.filters?.status || "",
      campaign:
        payloadData?.filters?.campaigns?.length > 0
          ? payloadData?.filters?.campaigns
          : [],
      callDurationText:
        payloadData?.filters?.callDuration?.length > 0
          ? payloadData?.filters?.callDuration
          : [],
      callDirection:
        payloadData?.filters?.callInteraction?.length > 0
          ? payloadData?.filters?.callInteraction
          : [],
      searchTerm: debouncedSearch,
      // complianceStatus:
      //   payloadData?.selectedCompliance?.length > 0
      //     ? payloadData?.selectedCompliance
      //     : [],
      disposition:
        payloadData?.filters?.disposition?.length > 0
          ? payloadData?.filters?.disposition
          : [],
      conversionStatus:
        payloadData?.filters?.conversionStatus?.length > 0
          ? payloadData?.filters?.conversionStatus
          : [],
      categoryDistribution:
        payloadData?.filters?.categoryDistribution?.length > 0
          ? payloadData?.filters?.categoryDistribution
          : [],
      subDisposition:
        payloadData?.filters?.subDisposition?.length > 0
          ? payloadData?.filters?.subDisposition
          : [],
      frequentKeywords: payloadData?.frequentKeywords || "",
      callScore:
        payloadData?.filters?.callScore?.length > 0
          ? payloadData?.filters?.callScore
          : [],
      page: page,
      limit: 10,
      pagination: true,
    };
    try {
      const listEndpoint = isKiwiCompany
        ? apiEndPointsConfig?.kiwiCallRecordingList
        : apiEndPointsConfig?.callRecordingList;
      const res = await axiosInstance.post(
        `${listEndpoint}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setData(res?.data?.data?.interactionList || []);
      setPaginationData(res?.data?.data?.paginator || {});
      setLoader(false);
    } catch (error) {
      console.error("Error fetching audio details", error);
    }
  };
  const exportToCSV = (data) => {
    if (!data || data.length === 0) return;

    // Extract keys (columns)
    const headers = Object.keys(data[0]);

    // Convert rows
    const rows = data.map((row) =>
      headers.map((field) => JSON.stringify(row[field] ?? "")).join(",")
    );

    // CSV string
    const csvContent = [headers.join(","), ...rows].join("\n");

    // Create & download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", `export_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const fetchExportDetails = async () => {
  //   const today = new Date();
  //   const payload = {
  //     startDate: payloadData?.filters?.startDate
  //       ? payloadData?.filters?.startDate
  //       : today?.toISOString().split("T")[0],
  //     endDate: payloadData?.filters?.endDate
  //       ? payloadData?.filters?.endDate
  //       : today?.toISOString().split("T")[0],
  //     agentName:
  //       payloadData?.filters?.agents?.length > 0
  //         ? payloadData?.filters?.agents
  //         : [],
  //     sentiment:
  //       payloadData?.filters?.sentiment?.length > 0
  //         ? payloadData?.filters?.sentiment
  //         : [],
  //     campaign:
  //       payloadData?.filters?.campaigns?.length > 0
  //         ? payloadData?.filters?.campaigns
  //         : [],
  //     callDurationText:
  //       payloadData?.filters?.callDuration?.length > 0
  //         ? payloadData?.filters?.callDuration
  //         : [],
  //     callDirection:
  //       payloadData?.filters?.callInteraction?.length > 0
  //         ? payloadData?.filters?.callInteraction
  //         : [],
  //     searchTerm: searchQuery,
  //     // complianceStatus:
  //     //   payloadData?.selectedCompliance?.length > 0
  //     //     ? payloadData?.selectedCompliance
  //     //     : [],
  //     disposition:
  //       payloadData?.filters?.disposition?.length > 0
  //         ? payloadData?.filters?.disposition
  //         : [],
  //     subDisposition:
  //       payloadData?.filters?.subDisposition?.length > 0
  //         ? payloadData?.filters?.subDisposition
  //         : [],
  //     frequentKeywords: payloadData?.frequentKeywords || "",
  //     callScore:
  //       payloadData?.filters?.callScore?.length > 0
  //         ? payloadData?.filters?.callScore
  //         : [],
  //     page: page,
  //     limit: 10,
  //     pagination: false,
  //   };
  //   try {
  //     const res = await axiosInstance.post(
  //       `${apiEndPointsConfig?.interactionList}`,
  //       payload,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     const exportList = res?.data?.data?.interactionList || [];
  //     setExportData(res?.data?.data?.interactionList || []);
  //     exportToCSV(exportList);
  //   } catch (error) {
  //     console.error("Error fetching audio details", error);
  //   }
  // };

  const fetchExportExcel = async () => {
    setIsExporting(true);
    const today = new Date();
    const payload = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
      agentName:
        payloadData?.filters?.agents?.length > 0
          ? payloadData?.filters?.agents
          : [],
      sentiment:
        payloadData?.filters?.sentiment?.length > 0
          ? payloadData?.filters?.sentiment
          : [],
      campaign:
        payloadData?.filters?.campaigns?.length > 0
          ? payloadData?.filters?.campaigns
          : [],
      callDurationText:
        payloadData?.filters?.callDuration?.length > 0
          ? payloadData?.filters?.callDuration
          : [],
      callDirection:
        payloadData?.filters?.callInteraction?.length > 0
          ? payloadData?.filters?.callInteraction
          : [],
      searchTerm: debouncedSearch,
      disposition:
        payloadData?.filters?.disposition?.length > 0
          ? payloadData?.filters?.disposition
          : [],
      conversionStatus:
        payloadData?.filters?.conversionStatus?.length > 0
          ? payloadData?.filters?.conversionStatus
          : [],
      categoryDistribution:
        payloadData?.filters?.categoryDistribution?.length > 0
          ? payloadData?.filters?.categoryDistribution
          : [],
      subDisposition:
        payloadData?.filters?.subDisposition?.length > 0
          ? payloadData?.filters?.subDisposition
          : [],
      frequentKeywords: payloadData?.frequentKeywords || "",
      callScore:
        payloadData?.filters?.callScore?.length > 0
          ? payloadData?.filters?.callScore
          : [],
    };

    try {
      const res = await axiosInstance.post(
        `${apiEndPointsConfig?.exportExcelInteraction}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      );

      console.log(res, "execl data of interaction----------------");


      if (!res.data) {
        console.error("No data received from server");
        setIsExporting(false);
        return;
      }

      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `interaction_export_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      // const exportList = res?.data?.data || [];
      // setExportData(res?.data?.data || []);
      // exportToCSV(exportList);

      setIsExporting(false);
      console.log("Export completed successfully");

    } catch (error) {
      console.error("Error exporting Excel file", error);
      console.error("Error details:", error.response || error.message);
      setIsExporting(false);
      alert("Failed to export data. Please try again.");
    }
  };

  const fetchAgentCampaignDetails = async () => {
    try {
      const filterEndpoint = isKiwiCompany
        ? apiEndPointsConfig?.kiwiFilterDetails
        : apiEndPointsConfig?.agentCampaignList;
      const res = await axiosInstance.get(
        `${filterEndpoint}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAgentList(res?.data?.data?.agentName);
      setCampaignList(res?.data?.data?.campaignName);
    } catch (error) {
      console.error("Error fetching audio details", error);
    }
  };


  console.log(payloadData, "payloadData");

  const extractMobile = (fileName) => {
    return fileName.split("-")[1]?.split(".")[0];
  };
  const getDisplayFileName = (fileName) => isKiwiCompany
    ? String(fileName || "-").replace(/-elevenlabs-/ig, "-")
    : (fileName || "-");
  const formatCallDuration = (seconds) => {
    const totalSeconds = Number(seconds || 0);
    if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return "-";
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = Math.floor(totalSeconds % 60);

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
    }

    return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
  };
  function compactId(id) {
    return id?.slice(-5);
  }
  const toTitleCase = (str = "") =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const handleExportExcel = () => { };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.transcriptionId);
      setSelectedRows(newSelecteds);
      return;
    }
    setSelectedRows([]);
  };

  const handleSelectRow = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }
    setSelectedRows(newSelected);
  };

  const handleUpdateQAParameters = async () => {
    if (selectedRows.length === 0) {
      setSnackbar({ open: true, message: "Please select at least one record to update.", severity: "warning" });
      return;
    }
    try {
      setIsUpdatingQA(true);
      const res = await axiosInstance.put(
        `${apiEndPointsConfig?.updateMultipleQaParameters}`,
        { transcriptionIds: selectedRows },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const message = res?.data?.message || "QA Parameters updated successfully!";
      setSnackbar({ open: true, message: message, severity: "success" });

      setSelectedRows([]);
      fetchAudioDetails();
    } catch (error) {
      console.error("Error updating QA parameters", error);
      const errorMessage = error?.response?.data?.message || "Failed to update QA parameters. Please try again.";
      setSnackbar({ open: true, message: errorMessage, severity: "error" });
    } finally {
      setIsUpdatingQA(false);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleToggleCuration = async (row) => {
    const nextIsCurated = !row.isCurated;
    try {
      await axiosInstance.post(
        apiEndPointsConfig.toggleCuration,
        { recordingId: row.recordingId, isCurated: nextIsCurated },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setData((prev) =>
        prev.map((item) =>
          item.recordingId === row.recordingId ? { ...item, isCurated: nextIsCurated } : item
        )
      );
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to update curation status.", severity: "error" });
    }
  };

  const handleToggleDownloadSelection = (conversationId) => {
    if (!conversationId) return;
    setSelectedDownloadIds((current) => current.includes(conversationId)
      ? current.filter((id) => id !== conversationId)
      : [...current, conversationId]);
  };

  const handleDownloadSelectedKiwi = async () => {
    if (!selectedDownloadIds.length) {
      setSnackbar({ open: true, message: "Select at least one recording to download.", severity: "warning" });
      return;
    }
    try {
      setIsDownloadingKiwi(true);
      const response = await axiosInstance.post(
        apiEndPointsConfig.kiwiCuratorDownload,
        { conversationIds: selectedDownloadIds },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const results = response?.data?.data?.results || [];
      const failed = results.filter((item) => item.status === "failed").length;
      setSnackbar({
        open: true,
        message: failed ? `${results.length - failed} downloaded, ${failed} failed.` : `${results.length} recording(s) downloaded successfully.`,
        severity: failed ? "warning" : "success"
      });
      setSelectedDownloadIds([]);
      fetchAudioDetails();
    } catch (error) {
      setSnackbar({ open: true, message: error?.response?.data?.message || "Failed to download Kiwi recordings.", severity: "error" });
    } finally {
      setIsDownloadingKiwi(false);
    }
  };

  const handleDownloadKiwiRow = async (row) => {
    if (!row?.conversationId) return;
    try {
      setDownloadingRowId(row.recordingId || row.conversationId);
      await axiosInstance.post(
        apiEndPointsConfig.kiwiCuratorDownload,
        { conversationIds: [row.conversationId] },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSnackbar({ open: true, message: "Recording downloaded successfully.", severity: "success" });
      fetchAudioDetails();
    } catch (error) {
      setSnackbar({ open: true, message: error?.response?.data?.message || "Failed to download recording.", severity: "error" });
    } finally {
      setDownloadingRowId(null);
    }
  };

  const handleOpenReprocessMenu = (event, row) => {
    setReprocessMenu({ anchorEl: event.currentTarget, row });
  };

  const handleCloseReprocessMenu = () => {
    setReprocessMenu({ anchorEl: null, row: null });
  };

  const handleReprocess = async (stage) => {
    const row = reprocessMenu.row;
    handleCloseReprocessMenu();
    if (!row?.recordingId) return;

    try {
      setReprocessingRowId(row.recordingId);
      await axiosInstance.post(
        `${apiEndPointsConfig?.reprocessCallRecording}/${row.recordingId}`,
        { stage },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSnackbar({ open: true, message: "Reprocessing started. This may take a few minutes.", severity: "success" });
    } catch (error) {
      const errorMessage = error?.response?.data?.status?.value || "Failed to start reprocessing. Please try again.";
      setSnackbar({ open: true, message: errorMessage, severity: "error" });
    } finally {
      setReprocessingRowId(null);
    }
  };

  const handleTogglePlay = (row) => {
    let src;
    if (isMPokket) {
      src = row.fileName ? `https://acolabz.com/uploads/${row.fileName}` : null;
    } else if (isNipponCompany || isKiwiCompany) {
      // Nippon's (and Kiwi's, same VM) recordings are served straight from nippon.convoze.com rather than
      // this app's stream proxy, matching AUDIO_BASE_URL + filePath in the API's
      // call-recording-pipeline-handler - the proxy reads off local disk, which only
      // has the file on whichever machine actually received the upload.
      const normalizedPath = row.filePath ? String(row.filePath).replace(/\\/g, "/").replace(/^\/+/, "") : null;
      const encodedPath = normalizedPath ? normalizedPath.split("/").map(encodeURIComponent).join("/") : null;
      src = encodedPath ? `${audioPath}/${encodedPath}` : null;
    } else {
      src = row.recordingId ? `${apiEndPointsConfig.streamAudio}/${row.recordingId}?token=${encodeURIComponent(token)}` : null;
    }

    if (!src) return;

    if (playingId === row.recordingId) {
      audioRef.current?.pause();
      setPlayingId(null);
      setCurrentTime(0);
      setDuration(0);
      return;
    }

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.ontimeupdate = null;
      audioRef.current.onloadedmetadata = null;
      audioRef.current.onended = null;
    }

    const audio = new Audio(src);
    audioRef.current = audio;

    audio.onloadedmetadata = () => {
      setDuration(audio.duration);
      audio.playbackRate = playbackSpeed;
    };
    audio.ontimeupdate = () => setCurrentTime(audio.currentTime);
    audio.onended = () => {
      setPlayingId(null);
      setCurrentTime(0);
      setDuration(0);
    };

    audio.onerror = () => {
      setPlayingId(null);
      setCurrentTime(0);
      setDuration(0);
      setSnackbar({ open: true, message: "This recording is not available on the server. Please download it again or contact an administrator.", severity: "warning" });
    };
    audio.play().catch(() => {
      setPlayingId(null);
      setCurrentTime(0);
      setDuration(0);
      setSnackbar({ open: true, message: "Unable to play this recording. The audio file may be unavailable.", severity: "warning" });
    });
    setPlayingId(row.recordingId);
    setCurrentTime(0);
    setDuration(0);
  };

  return (
    <Box sx={{}}>
      {loader ? (
        <Loader />
      ) : (
        <Box sx={{ p: { xs: 1.5, md: 3 }, backgroundColor: "#F8F8FA" }}>
          {/* Filters */}
          <Box
            sx={{
              // border: "1px solid #EEEEEE",
              // p: "10px 15px",
              borderRadius: 2.5,
              // backgroundColor: "#fff",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <TextField
                size="small"
                variant="outlined"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setPage(1);
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    // "& fieldset": {
                    //   borderColor: "#6366F1",
                    // },
                    "&:hover fieldset": {
                      borderColor: "#6366F1",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#6366F1",
                    },
                    "& .MuiInputBase-input": {
                      // color: "#6366F1",
                      // fontWeight: 600,
                      // p: "10px 20px",
                      fontSize: 14,
                    },
                    borderRadius: 2,
                    p: "5px 20px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Box
                      component="span"
                      sx={{
                        color: "#6366F1",
                        mr: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        width="20"
                        fill="#6366F1"
                      >
                        <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 14a4 4 0 110-8 4 4 0 010 8z" />
                      </svg>
                    </Box>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                alignItems: "center",
              }}
            >
              <CommonFilter
                storageName={"interactionFilter"}
                setPayloadData={setPayloadData}
                isFilter={isFilter}
                defaultDateRange="month"
              />
              {/* <Button
                variant="contained"
                color="primary"
                disabled={isUpdatingQA || selectedRows.length === 0}
                onClick={handleUpdateQAParameters}
                sx={{
                  height: "35px",
                  backgroundColor: "#7635dd",
                  borderRadius: "12px",
                  "&:hover": {
                    backgroundColor: "#5f2ab8",
                  },
                  "&:disabled": {
                    backgroundColor: "#c4b5e0",
                  },
                }}
                startIcon={
                  isUpdatingQA ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null
                }
              >
                {isUpdatingQA ? "Updating..." : "Update QA"}
              </Button> */}
              {/* <Button
                variant="contained"
                color="primary"
                sx={{
                  height: "35px",
                  width: { xs: "100%", lg: "150px" },
                  backgroundColor: "#7635dd",
                  borderRadius: "12px",
                }}
                onClick={fetchExportDetails}
              >
                Export
              </Button> */}
              <Button
                variant="contained"
                color="primary"
                disabled={isExporting}
                sx={{
                  height: "35px",
                  width: { xs: "100%", lg: "150px" },
                  backgroundColor: "#7635dd",
                  borderRadius: "12px",
                  "&:hover": {
                    backgroundColor: "#5f2ab8",
                  },
                  "&:disabled": {
                    backgroundColor: "#c4b5e0",
                  },
                }}
                onClick={fetchExportExcel}
                startIcon={
                  isExporting ? (
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                  ) : null
                }
              >
                {isExporting ? "Exporting..." : "Export"}
              </Button>
              {isKiwiCompany && isCurator && (
                <Button
                  variant="outlined"
                  disabled={isDownloadingKiwi || !selectedDownloadIds.length}
                  onClick={handleDownloadSelectedKiwi}
                  startIcon={isDownloadingKiwi ? <CircularProgress size={16} /> : null}
                  sx={{ height: "35px", borderRadius: "12px", textTransform: "none" }}
                >
                  {isDownloadingKiwi ? "Downloading..." : `Download selected${selectedDownloadIds.length ? ` (${selectedDownloadIds.length})` : ""}`}
                </Button>
              )}
            </Box>
          </Box>

          <KiwiElevenLabsPanel onRefresh={fetchAudioDetails} />

          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              border: "1px solid #EEEEEE",
              borderRadius: 2,
              overflowX: "auto",
              mt: 3,
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {isKiwiCompany && isCurator && (
                    <TableHeading sx={{ width: 48, textAlign: "center" }}>
                      <Checkbox
                        size="small"
                        checked={data.length > 0 && data.filter((row) => row.conversationId).every((row) => selectedDownloadIds.includes(row.conversationId))}
                        onChange={(event) => setSelectedDownloadIds(event.target.checked ? data.map((row) => row.conversationId).filter(Boolean) : [])}
                      />
                    </TableHeading>
                  )}
                  <TableHeading>{isKiwiCompany ? "Conversation Date & Time" : "Recording Date"}</TableHeading>
                  <TableHeading>File</TableHeading>
                  {!isKiwiCompany && <TableHeading>Branch Manager Name</TableHeading>}
                  <TableHeading>{isKiwiCompany ? "Customer Name" : "Candidate Name"}</TableHeading>
                  <TableHeading>Mobile Number</TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>Call Type</TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>Language</TableHeading>
                  {isKiwiCompany && (
                    <TableHeading sx={{ textAlign: "center" }}>Duration</TableHeading>
                  )}
                  <TableHeading sx={{ textAlign: "center" }}>Processing Status</TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>Action</TableHeading>
                  {!hideReportColumn && (
                    <TableHeading sx={{ textAlign: "center" }}>Report</TableHeading>
                  )}
                  {isCurator && (
                    <TableHeading sx={{ textAlign: "center" }}>Curate</TableHeading>
                  )}
                  {isCurator && (
                    <TableHeading sx={{ textAlign: "center" }}>Reprocess</TableHeading>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length == 0 ? (
                  <TableRow>
                      <TableCell colSpan={(isKiwiCompany ? 9 : 9) + (!hideReportColumn ? 1 : 0) + (isCurator ? 2 : 0) + (isKiwiCompany && isCurator ? 1 : 0)} align="center">
                      <NoData />
                    </TableCell>
                  </TableRow>
                ) : (
                  data?.map((row, index) => {
                    const rowKey = row?.recordingId || row?.conversationId || row?.transcriptionId || `${row?.fileName || "audio"}-${index}`;
                    return (
                  <TableRow key={rowKey} hover>
                      {isKiwiCompany && isCurator && (
                        <TableCell sx={{ textAlign: "center" }}>
                          <Checkbox
                            size="small"
                            checked={selectedDownloadIds.includes(row.conversationId)}
                            disabled={!row.conversationId}
                            onChange={() => handleToggleDownloadSelection(row.conversationId)}
                          />
                        </TableCell>
                      )}
                      {/* Recording Date */}
                      <TableCell sx={{ fontSize: "0.8rem", fontWeight: 520, whiteSpace: "nowrap" }}>
                        <FormattedDate dateString={isKiwiCompany ? row?.conversationDateTime : row?.createdOn} />
                      </TableCell>

                      {/* File */}
                      <TableCell
                        sx={{
                          fontSize: "0.8rem",
                          color: "#666666",
                          maxWidth: 220,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={getDisplayFileName(row?.fileName)}
                      >
                        {getDisplayFileName(row?.fileName)}
                      </TableCell>

                      {/* Branch Manager Name */}
                      {!isKiwiCompany && (
                        <TableCell sx={{ fontSize: "0.8rem", fontWeight: 550, whiteSpace: "nowrap" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Avatar sx={{ bgcolor: "#7635DD", width: 28, height: 28, fontSize: 12 }}>
                              {getFirstLetter(row?.uploadedByName || row?.agentName) || "B"}
                            </Avatar>
                            {row?.uploadedByName || row?.agentName || "-"}
                          </Box>
                        </TableCell>
                      )}

                      {/* Candidate Name */}
                      <TableCell sx={{ fontSize: "0.8rem", color: "#666666", whiteSpace: "nowrap" }}>
                        {row?.candidateName || row?.customerName || "-"}
                      </TableCell>

                      {/* Mobile Number */}
                      <TableCell sx={{ fontSize: "0.8rem", color: "#666666", whiteSpace: "nowrap" }}>
                        {row?.mobileNumber
                          ? "x".repeat(String(row.mobileNumber).length - 4) + String(row.mobileNumber).slice(-4)
                          : "-"}
                      </TableCell>

                      {/* Call Type */}
                      <TableCell sx={{ textAlign: "center" }}>
                        {row?.callType ? (
                          <Chip
                            label={row.callType}
                            size="small"
                            sx={{
                              backgroundColor: row.callType === "New Call" ? "#E9EFFC" : "#FEF3E2",
                              color: row.callType === "New Call" ? "#2463EB" : "#B45309",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              borderRadius: 2,
                            }}
                          />
                        ) : (
                          <Typography fontSize="0.75rem" color="text.disabled">-</Typography>
                        )}
                      </TableCell>

                      {/* Language */}
                      <TableCell sx={{ textAlign: "center", fontSize: "0.8rem", color: "#666666" }}>
                        {LANGUAGE_MAP[row?.language] || row?.language || "-"}
                      </TableCell>

                      {/* Duration */}
                      {isKiwiCompany && (
                        <TableCell sx={{ textAlign: "center", fontSize: "0.8rem", color: "#374151", whiteSpace: "nowrap", fontWeight: 550 }}>
                          {formatCallDuration(row?.callDurationSecs)}
                        </TableCell>
                      )}

                      {/* Processing Status */}
                      <TableCell sx={{ textAlign: "center" }}>
                        <Chip
                          label={
                            row?.transcriptionStatus === "Completed"
                              ? "Completed"
                              : row?.transcriptionStatus === "Failed"
                              ? "Failed"
                              : row?.transcriptionStatus === "Pending"
                              ? (isCurator ? "Pending Curation" : "Processing")
                              : "In Progress"
                          }
                          size="small"
                          sx={{
                            backgroundColor:
                              row?.transcriptionStatus === "Completed"
                                ? "#E8F5E9"
                                : row?.transcriptionStatus === "Failed"
                                ? "#FFEBEE"
                                : "#FFF8E1",
                            color:
                              row?.transcriptionStatus === "Completed"
                                ? "green"
                                : row?.transcriptionStatus === "Failed"
                                ? "#FF4D4F"
                                : "#F59E0B",
                            fontWeight: 600,
                            borderRadius: 2,
                          }}
                        />
                      </TableCell>

                      {/* Action - Play Audio */}
                      <TableCell sx={{ textAlign: "center" }}>
                        {row?.recordingId ? (
                          playingId === row.recordingId ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                bgcolor: "#f8f9fa",
                                p: "6px 10px",
                                borderRadius: 2,
                                minWidth: 260,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => handleTogglePlay(row)}
                                sx={{
                                  bgcolor: "#7635DD",
                                  color: "white",
                                  "&:hover": { bgcolor: "#5f2bb3" },
                                  width: 28,
                                  height: 28,
                                  flexShrink: 0,
                                }}
                              >
                                <PauseIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                              <Slider
                                min={0}
                                max={duration || 0}
                                value={currentTime}
                                onChange={(e, val) => {
                                  if (audioRef.current) {
                                    audioRef.current.currentTime = val;
                                    setCurrentTime(val);
                                  }
                                }}
                                sx={{ flex: 1, color: "#7635DD", py: "6px" }}
                                size="small"
                              />
                              <Typography
                                variant="caption"
                                sx={{ whiteSpace: "nowrap", flexShrink: 0, fontSize: "0.65rem", color: "#555" }}
                              >
                                {formatTime(currentTime)} / {formatTime(duration)}
                              </Typography>
                              <Box sx={{ display: "flex", gap: 0.3, flexShrink: 0 }}>
                                {[1, 1.5, 2].map((speed) => (
                                  <Button
                                    key={speed}
                                    onClick={() => {
                                      setPlaybackSpeed(speed);
                                      if (audioRef.current) audioRef.current.playbackRate = speed;
                                    }}
                                    sx={{
                                      minWidth: "28px",
                                      height: "18px",
                                      p: "1px 3px",
                                      fontSize: "9px",
                                      fontWeight: 700,
                                      borderRadius: "4px",
                                      bgcolor: playbackSpeed === speed ? "#7635DD" : "transparent",
                                      color: playbackSpeed === speed ? "white" : "#7635DD",
                                      border: "1px solid #7635DD",
                                      textTransform: "none",
                                      "&:hover": {
                                        bgcolor: playbackSpeed === speed ? "#5f2bb3" : "rgba(118,53,221,0.08)",
                                        border: "1px solid #7635DD",
                                      },
                                    }}
                                  >
                                    {speed}x
                                  </Button>
                                ))}
                              </Box>
                            </Box>
                          ) : (
                            <Tooltip title="Play Audio">
                              <IconButton
                                size="small"
                                onClick={() => handleTogglePlay(row)}
                                sx={{ color: "#7C3AED" }}
                              >
                                <PlayCircleIcon sx={{ fontSize: 28 }} />
                              </IconButton>
                            </Tooltip>
                          )
                        ) : (
                          <Typography fontSize="0.75rem" color="text.disabled">-</Typography>
                        )}
                      </TableCell>

                      {/* Report */}
                      {!hideReportColumn && (
                        <TableCell sx={{ textAlign: "center" }}>
                          <Tooltip title={/* isReportGated && !row?.isCurated ? "Awaiting curation" : */ ""}>
                            <span>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={
                                  isCurator
                                    ? !row?.transcriptionReady
                                    : isKiwiCompany
                                      ? !row?.reportReady
                                    : decodedToken?.companyId === "6a635ef66fb85dcdebe3d9b6"
                                      ? !row?.reportReady
                                      : row?.transcriptionStatus !== "Completed"
                                  // || (isReportGated && !row?.isCurated)
                                }
                                onClick={() =>
                                  window.open(
                                    `/user/audio-analytics/${row.transcriptionId}`,
                                    "_blank"
                                  )
                                }
                                sx={{
                                  borderRadius: 2,
                                  color: "#7635DD",
                                  borderColor: "#7635DD",
                                  fontSize: "0.75rem",
                                  textTransform: "none",
                                  "&:hover": { backgroundColor: "#F4EFFC" },
                                  "&:disabled": { borderColor: "#ccc", color: "#ccc" },
                                }}
                              >
                                View Report
                              </Button>
                            </span>
                          </Tooltip>
                        </TableCell>
                      )}

                      {/* Curation toggle - Curator only */}
                      {isCurator && (
                        <TableCell sx={{ textAlign: "center" }}>
                          {isKiwiCompany && (
                            <Button
                              variant="outlined"
                              size="small"
                              disabled={!row?.conversationId || downloadingRowId === (row.recordingId || row.conversationId)}
                              onClick={() => handleDownloadKiwiRow(row)}
                              startIcon={downloadingRowId === (row.recordingId || row.conversationId) ? <CircularProgress size={14} /> : <AutorenewIcon sx={{ fontSize: 16 }} />}
                              sx={{
                                borderRadius: 5,
                                fontSize: "0.7rem",
                                textTransform: "none",
                                color: "#7635DD",
                                borderColor: "#7635DD",
                                mr: 1,
                                "&:hover": { backgroundColor: "#F4EFFC", borderColor: "#7635DD" },
                              }}
                            >
                              {row?.fileAvailable === false || row?.downloadStatus === "failed" ? "Retry download" : "Download"}
                            </Button>
                          )}
                          <Button
                            variant={row?.isCurated ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleToggleCuration(row)}
                            sx={{
                              borderRadius: 5,
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              px: 2,
                              ...(row?.isCurated
                                ? {
                                    backgroundColor: "#7635DD",
                                    color: "#fff",
                                    "&:hover": { backgroundColor: "#5f2bb3" },
                                  }
                                : {
                                    color: "#666666",
                                    borderColor: "#cccccc",
                                    "&:hover": { backgroundColor: "#F4EFFC", borderColor: "#7635DD" },
                                  }),
                            }}
                          >
                            {row?.isCurated ? "Curated" : "Curate"}
                          </Button>
                        </TableCell>
                      )}

                      {/* Reprocess menu - Curator only */}
                      {isCurator && (
                        <TableCell sx={{ textAlign: "center" }}>
                          <Button
                            variant="outlined"
                            size="small"
                            disabled={!row?.recordingId || reprocessingRowId === row.recordingId}
                            onClick={(event) => handleOpenReprocessMenu(event, row)}
                            startIcon={
                              reprocessingRowId === row.recordingId ? (
                                <CircularProgress size={14} sx={{ color: "#7635DD" }} />
                              ) : (
                                <AutorenewIcon sx={{ fontSize: 16 }} />
                              )
                            }
                            sx={{
                              borderRadius: 5,
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              textTransform: "none",
                              color: "#7635DD",
                              borderColor: "#7635DD",
                              "&:hover": { backgroundColor: "#F4EFFC", borderColor: "#7635DD" },
                            }}
                          >
                            Reprocess
                          </Button>
                        </TableCell>
                      )}
                    </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Stack
            spacing={2}
            sx={{ mt: 2, display: "flex", alignItems: "flex-end", p: 2 }}
          >
            <Typography variant="body2" color="text.secondary">
              {paginationData?.itemCount > 0
                ? `Showing ${(paginationData?.currentPage - 1) *
                paginationData?.perPage +
                1
                }-${Math.min(
                  paginationData?.currentPage * paginationData?.perPage,
                  paginationData?.itemCount
                )} of ${paginationData?.itemCount} results`
                : "No results found"}
            </Typography>

            <Pagination
              count={paginationData?.pageCount || 1}
              page={paginationData?.currentPage || 1}
              onChange={(event, value) => {
                setPage(value);
              }}
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "#7635DD",
                  borderColor: "#7635DD",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#7635DD !important",
                  color: "#fff !important",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#E0E7FF",
                },
              }}
            />
          </Stack>
        </Box>
      )}
      <Menu
        anchorEl={reprocessMenu.anchorEl}
        open={Boolean(reprocessMenu.anchorEl)}
        onClose={handleCloseReprocessMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={() => handleReprocess("transcription")}>
          <ListItemIcon>
            <MicIcon fontSize="small" sx={{ color: "#7635DD" }} />
          </ListItemIcon>
          <ListItemText>Reprocess Transcription</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleReprocess("interaction")}>
          <ListItemIcon>
            <ForumIcon fontSize="small" sx={{ color: "#7635DD" }} />
          </ListItemIcon>
          <ListItemText>Reprocess Interaction</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleReprocess("callAdherence")}>
          <ListItemIcon>
            <FactCheckIcon fontSize="small" sx={{ color: "#7635DD" }} />
          </ListItemIcon>
          <ListItemText>Reprocess Call Adherence</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleReprocess("all")}>
          <ListItemIcon>
            <DoneAllIcon fontSize="small" sx={{ color: "#7635DD" }} />
          </ListItemIcon>
          <ListItemText>Reprocess All</ListItemText>
        </MenuItem>
      </Menu>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%", boxShadow: 3 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AudioTable;

// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Paper,
//   Stack,
//   Pagination,
//   TextField,
//   styled,
//   Avatar,
//   Chip,
//   Button,
// } from "@mui/material";
// import { useDebounce } from "react-use";
// import { jwtDecode } from "jwt-decode";

// import axiosInstance from "../../../services/axiosInterceptors";
// import apiEndPointsConfig from "../../../services/apiEndPoints";
// import Header from "../../../components/header";
// import Loader from "../../../components/AnimatedLoader";
// import NoData from "../../../components/NoData";
// import CommonFilter from "../../../components/CommonFilter";
// import FormattedDate from "../../../components/FormattedDate";
// import { convertCallDuration, getFirstLetter } from "../../../utils/common";
// import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
// import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
// import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
// import CallReceivedIcon from "@mui/icons-material/CallReceived";
// import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
// import dialerIcon from "../../../assets/table_call_icon.svg";
// import { palette, theme as colorTheme } from "../../../Convoze.theme";
// import ParentWrapper from "../../../components/ParentWrapper";

// /* ---------- styled ---------- */
// const TableHeading = styled(TableCell)({
//   textTransform: "uppercase",
//   fontWeight: 550,
//   // color: "#6b7280",
//   color: colorTheme("palette", "secondary").value,
//   fontSize: "0.7rem",
//   backgroundColor: "white",
//   whiteSpace: "nowrap",
// });

// /* ---------- helpers ---------- */
// const buildCacheKey = (page, payload, search) =>
//   `p${page}-${JSON.stringify(payload)}-${search}`;

// const compactId = (id) => id?.slice(-5);
// const toTitleCase = (str = "") =>
//   str
//     .toLowerCase()
//     .split(" ")
//     .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
//     .join(" ");

// /* ========== SUB-COMPONENTS ========== */
// const SearchBar = ({ value, onChange }) => (
//   <TextField
//     size="small"
//     placeholder="Search"
//     value={value}
//     onChange={onChange}
//     sx={{
//       width: { xs: "100%", md: "100%", lg: "20%" },
//       backgroundColor: colorTheme("palette", "white").value,
//       borderRadius: 2,
//       "& .MuiOutlinedInput-root": {
//         p: "1px 20px",
//         "&:hover fieldset": {
//           borderColor: colorTheme("palette", "primary").value,
//         },
//         "&.Mui-focused fieldset": {
//           borderColor: colorTheme("palette", "primary").value,
//         },
//         "& .MuiInputBase-input": { fontSize: 14 },
//         borderRadius: 3,
//       },
//     }}
//     InputProps={{
//       startAdornment: (
//         <Box
//           component="span"
//           sx={{
//             color: colorTheme("palette", "primary").value,
//             mr: 1,
//             display: "flex",
//           }}
//         >
//           <svg
//             width="20"
//             height="20"
//             viewBox="0 0 24 24"
//             fill={colorTheme("palette", "primary").value}
//           >
//             <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 14a4 4 0 110-8 4 4 0 010 8z" />
//           </svg>
//         </Box>
//       ),
//     }}
//   />
// );

// const AgentCell = ({ row }) => (
//   <TableCell
//     sx={{
//       cursor: "pointer",
//       color:
//         row?.transcriptionStatus === "Completed"
//           ? colorTheme("palette", "primary").value
//           : colorTheme("palette", "secondary").value,
//       whiteSpace: "nowrap",
//       fontSize: "0.8rem",
//       fontWeight: 550,
//       "&:hover": {
//         color:
//           row?.transcriptionStatus === "Completed"
//             ? colorTheme("palette", "primary").value
//             : colorTheme("palette", "secondary").value,
//       },
//     }}
//     onClick={() =>
//       row?.transcriptionStatus === "Completed" &&
//       window.open(`/user/audio-analytics/${row.transcriptionId}`, "_blank")
//     }
//   >
//     <Box sx={{ display: "flex", gap: 1 }}>
//       <Avatar
//         sx={{
//           // bgcolor: "#7635DD",
//           bgcolor: colorTheme("palette", "primary").value,
//           width: 28,
//           height: 28,
//           fontSize: 12,
//           // border: "1px solid #7635DD",
//           border: `1px solid ${colorTheme("palette", "primary").value}`,
//         }}
//       >
//         {getFirstLetter(row?.agentName) || "NA"}
//       </Avatar>
//       <Box sx={{ display: "flex", flexDirection: "column" }}>
//         <Box>{row?.agentName}</Box>
//         <Box
//           sx={{
//             fontWeight: 500,
//             color: colorTheme("palette", "secondary").value,
//             fontSize: 12,
//           }}
//         >
//           Agent ID: #{compactId(row?.agentId)}
//         </Box>
//       </Box>
//     </Box>
//   </TableCell>
// );

// const CustomerCell = ({ row }) => (
//   <TableCell
//     sx={{
//       color: "grey",
//       whiteSpace: "nowrap",
//       fontSize: "0.8rem",
//       fontWeight: 550,
//     }}
//   >
//     <Box sx={{ display: "flex", gap: 1 }}>
//       <Avatar
//         sx={{
//           fontSize: 12,
//           bgcolor: colorTheme("palette", "secondary").value,
//           width: 28,
//           height: 28,
//         }}
//       >
//         {getFirstLetter(row?.customerName) || "U"}
//       </Avatar>
//       <Box sx={{ display: "flex", flexDirection: "column" }}>
//         <Box>
//           {row?.customerName ? toTitleCase(row?.customerName) : "Unknown"}
//         </Box>
//         <Box
//           sx={{
//             fontWeight: 500,
//             color: colorTheme("palette", "secondary").value,
//             fontSize: 12,
//           }}
//         >
//           Customer
//         </Box>
//       </Box>
//     </Box>
//   </TableCell>
// );

// const IntentCell = ({ intent }) => (
//   <TableCell
//     sx={{ fontSize: "0.8rem", color: colorTheme("palette", "secondary").value }}
//   >
//     <Box sx={{ fontWeight: "bold" }}>{intent}</Box>
//   </TableCell>
// );

// const CampaignCell = ({ campaign }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.7rem",
//       color: colorTheme("palette", "secondary").value,
//       whiteSpace: "nowrap",
//     }}
//   >
//     <Box
//       sx={{
//         display: "inline-block",
//         borderRadius: 2,
//         // border: "1px solid grey",
//         border: `1px solid ${colorTheme("palette", "secondary").value}`,
//         p: 0.5,
//         width: "100%",
//         textAlign: "center",
//       }}
//     >
//       {campaign}
//     </Box>
//   </TableCell>
// );

// const DurationCell = ({ duration }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.8rem",
//       fontWeight: 550,
//       color: colorTheme("palette", "secondary").value,
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 1,
//       }}
//     >
//       <Box
//         component="img"
//         src={dialerIcon}
//         alt="call"
//         sx={{ width: 20, height: 20, objectFit: "contain" }}
//       />
//       {convertCallDuration(duration)}
//     </Box>
//   </TableCell>
// );

// const DirectionCell = ({ direction }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.8rem",
//       fontWeight: 550,
//       color: colorTheme("palette", "secondary").value,
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 0.5,
//       }}
//     >
//       {direction === "Inbound" ? (
//         <>
//           <CallReceivedIcon
//             sx={{ fontSize: 18, color: colorTheme("palette", "primary").value }}
//           />
//           <Box
//             sx={{
//               textTransform: "capitalize",
//               color: colorTheme("palette", "primary").value,
//               fontWeight: 600,
//             }}
//           >
//             {direction}
//           </Box>
//         </>
//       ) : (
//         <>
//           <ArrowOutwardIcon
//             sx={{ fontSize: 18, color: colorTheme("palette", "primary").value }}
//           />
//           <Box
//             sx={{
//               textTransform: "capitalize",
//               color: colorTheme("palette", "primary").value,
//               fontWeight: 600,
//             }}
//           >
//             {direction}
//           </Box>
//         </>
//       )}
//     </Box>
//   </TableCell>
// );

// const SentimentCell = ({ sentiment }) => (
//   <TableCell>
//     <Typography
//       sx={{
//         color:
//           sentiment === "Neutral"
//             ? colorTheme("palette", "neutral").value
//             : sentiment === "Positive"
//               ? colorTheme("palette", "positive").value
//               : colorTheme("palette", "negative").value,
//       }}
//       variant="body2"
//       fontWeight={600}
//       display="flex"
//       alignItems="center"
//       justifyContent="center"
//     >
//       {sentiment === "Unknown" ? (
//         <Box sx={{ color: "black" }}>N/A</Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1 }}>
//           {sentiment === "Negative" && (
//             <SentimentVeryDissatisfiedIcon
//               style={{ color: colorTheme("palette", "negative").value }}
//             />
//           )}
//           {sentiment === "Neutral" && (
//             <SentimentNeutralIcon
//               sx={{
//                 color: colorTheme("palette", "neutral").value,
//                 fontSize: 22,
//               }}
//             />
//           )}
//           {sentiment === "Positive" && (
//             <SentimentSatisfiedAltIcon
//               style={{ color: colorTheme("palette", "positive").value }}
//             />
//           )}
//           {sentiment}
//         </Box>
//       )}
//     </Typography>
//   </TableCell>
// );

// const ComplianceCell = ({ status, rating }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.8rem",
//       textAlign: "center",
//       fontWeight: 520,
//       color: colorTheme("palette", "night").value,
//     }}
//   >
//     {rating === "N/A" ? (
//       "N/A"
//     ) : (
//       <Chip
//         label={status ? "Pass" : "Fail"}
//         size="small"
//         sx={{
//           // backgroundColor: status ? colorTheme('palette', 'positive').value : colorTheme('palette', 'negative').value,
//           // color: colorTheme('palette', 'white').value,
//           background: "transparent",
//           border: `1px solid ${status
//             ? colorTheme("palette", "positive").value
//             : colorTheme("palette", "negative").value
//             }`,
//           color: status
//             ? colorTheme("palette", "positive").value
//             : colorTheme("palette", "negative").value,
//           px: 0.5,
//           py: 0.5,
//           borderRadius: 20,
//           fontWeight: 700,
//         }}
//       />
//     )}
//   </TableCell>
// );

// const DateCell = ({ date }) => (
//   <TableCell sx={{ fontSize: "0.8rem", fontWeight: 520, textAlign: "center" }}>
//     <FormattedDate dateString={date} />
//   </TableCell>
// );

// /* ========== MAIN COMPONENT ========== */
// const AudioTable = () => {
//   const token = localStorage.getItem("token");
//   const decodedToken = token ? jwtDecode(token) : "";

//   /* ---------------- state ---------------- */
//   const [audioList, setAudioList] = useState([]);
//   const [agentList, setAgentList] = useState([]);
//   const [campaignList, setCampaignList] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(true);
//   const [searchInput, setSearchInput] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [paginationInfo, setPaginationInfo] = useState({});
//   const [filterPayload, setFilterPayload] = useState();
//   const [cacheMap, setCacheMap] = useState({});

//   /* -------------- debounce -------------- */
//   useDebounce(() => setDebouncedSearch(searchInput), 400, [searchInput]);

//   /* -------------- data -------------- */
//   const fetchAudioDetails = useCallback(async () => {
//     const today = new Date().toISOString().split("T")[0];

//     const body = {
//       startDate: filterPayload?.filters?.startDate || today,
//       endDate: filterPayload?.filters?.endDate || today,
//       agentName: filterPayload?.filters?.agents?.length
//         ? filterPayload.filters.agents
//         : [],
//       sentiment: filterPayload?.filters?.sentiment?.length
//         ? filterPayload.filters.sentiment
//         : [],
//       campaign: filterPayload?.filters?.campaigns?.length
//         ? filterPayload.filters.campaigns
//         : [],
//       callDurationText: filterPayload?.filters?.callDuration?.length
//         ? filterPayload.filters.callDuration
//         : [],
//       callDirection: filterPayload?.filters?.callInteraction?.length
//         ? filterPayload.filters.callInteraction
//         : [],
//       disposition: filterPayload?.filters?.disposition?.length
//         ? filterPayload.filters.disposition
//         : [],
//       subDisposition: filterPayload?.filters?.subDisposition?.length
//         ? filterPayload.filters.subDisposition
//         : [],
//       callScore: filterPayload?.filters?.callScore?.length
//         ? filterPayload.filters.callScore
//         : [],
//       frequentKeywords: filterPayload?.frequentKeywords || "",
//       searchTerm: debouncedSearch,
//       page: currentPage,
//       limit: 10,
//       pagination: true,
//     };

//     const key = buildCacheKey(currentPage, filterPayload, debouncedSearch);

//     if (cacheMap[key]) {
//       console.log("AudioTable: cache hit", key);
//       setAudioList(cacheMap[key].list);
//       setPaginationInfo(cacheMap[key].pagination);
//       setIsLoading(false);
//       return;
//     }

//     try {
//       console.log("AudioTable: API call", key);
//       const res = await axiosInstance.post(
//         apiEndPointsConfig.interactionList,
//         body,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const list = res?.data?.data?.interactionList || [];
//       const paginator = res?.data?.data?.paginator || {};
//       setAudioList(list);
//       setPaginationInfo(paginator);
//       setCacheMap((prev) => ({
//         ...prev,
//         [key]: { list, pagination: paginator },
//       }));
//     } catch (err) {
//       console.error("AudioTable: API error", err);
//       setAudioList([]);
//       setPaginationInfo({});
//     } finally {
//       setIsLoading(false);
//     }
//   }, [currentPage, filterPayload, debouncedSearch, cacheMap, token]);

//   const fetchAgentAndCampaigns = useCallback(async () => {
//     try {
//       const res = await axiosInstance.get(
//         apiEndPointsConfig.agentCampaignList,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setAgentList(res?.data?.data?.agentName || []);
//       setCampaignList(res?.data?.data?.campaignName || []);
//     } catch (err) {
//       console.error("AudioTable: agents/campaigns error", err);
//     }
//   }, [token]);

//   /* -------------- effects -------------- */
//   useEffect(() => {
//     fetchAudioDetails();
//   }, [fetchAudioDetails]);

//   useEffect(() => {
//     fetchAgentAndCampaigns();
//   }, [fetchAgentAndCampaigns]);

//   // set current page to one add new
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filterPayload, debouncedSearch]);

//   /* -------------- render -------------- */
//   const isFilter = { date: true, filter: true };

//   // if (isLoading) return <Loader />;

//   // return (
//   //   <Box sx={{ ml: { xs: "0px", md: "280px" } }}>
//   //     <Box sx={{ display: { xs: "none", md: "initial" } }}>
//   //       <Header title="Interactions" />
//   //     </Box>

//   //     <Box sx={{ p: { xs: 1.5, md: 3 }, backgroundColor: "#F8F8FA" }}>
//   //       {/* Search + Filters */}
//   //       <Box sx={{ borderRadius: 2.5, display: "flex", justifyContent: "space-between" }}>
//   //         <SearchBar value={searchInput} onChange={(e) => { setSearchInput(e.target.value); setCurrentPage(1); }} />
//   //         <CommonFilter storageName="interactionFilter" setPayloadData={setFilterPayload} isFilter={isFilter} />
//   //       </Box>

//   // {/* Table */}
//   // <TableContainer component={Paper} sx={{ border: "1px solid #EEEEEE", borderRadius: 2, overflowX: "auto", mt: 3 }}>
//   //   <Table>
//   //     <TableHead>
//   //       <TableRow>
//   //         <TableHeading>Agent</TableHeading>
//   //         <TableHeading>Customer</TableHeading>
//   //         <TableHeading>Call Intent</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Campaign</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Duration</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Direction</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Sentiment</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Compliance</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Created On</TableHeading>
//   //       </TableRow>
//   //     </TableHead>
//   //     <TableBody>
//   //       {audioList.length === 0 ? (
//   //         <TableRow>
//   //           <TableCell colSpan={10} align="center">
//   //             <NoData />
//   //           </TableCell>
//   //         </TableRow>
//   //       ) : (
//   //         audioList.map((row) => (
//   //           <TableRow key={row.id}>
//   //             <AgentCell row={row} />
//   //             <CustomerCell row={row} />
//   //             <IntentCell intent={row.callIntent} />
//   //             <CampaignCell campaign={row.campaignName} />
//   //             <DurationCell duration={row.callDuration} />
//   //             <DirectionCell direction={row.callDirection} />
//   //             <SentimentCell sentiment={row.overAllSentiment} />
//   //             <ComplianceCell status={row.complianceStatus} rating={row.callAdherenceRating} />
//   //             <DateCell date={row.createdOn} />
//   //           </TableRow>
//   //         ))
//   //       )}
//   //     </TableBody>
//   //   </Table>
//   // </TableContainer>

//   // {/* Pagination */}
//   // <Stack spacing={2} sx={{ mt: 2, display: "flex", alignItems: "flex-end", p: 2 }}>
//   //   <Typography variant="body2" color="text.secondary">
//   //     {paginationInfo.itemCount > 0
//   //       ? `Showing ${(paginationInfo.currentPage - 1) * paginationInfo.perPage + 1}-${Math.min(
//   //           paginationInfo.currentPage * paginationInfo.perPage,
//   //           paginationInfo.itemCount
//   //         )} of ${paginationInfo.itemCount} results`
//   //       : "No results found"}
//   //   </Typography>
//   //   <Pagination
//   //     count={paginationInfo.pageCount || 1}
//   //     page={paginationInfo.currentPage || 1}
//   //     onChange={(e, v) => setCurrentPage(v)}
//   //     sx={{
//   //       "& .MuiPaginationItem-root": { color: "#6366F1", borderColor: "#6366F1" },
//   //       "& .MuiPaginationItem-root.Mui-selected": { backgroundColor: "#6366F1 !important", color: "#fff !important" },
//   //       "& .MuiPaginationItem-root:hover": { backgroundColor: "#E0E7FF" },
//   //     }}
//   //   />
//   // </Stack>
//   //     </Box>
//   //   </Box>
//   // );

//   return (
//     // <Box
//     //   sx={{

//     //     ml: {
//     //       xs: "0px",
//     //       md: "230px",
//     //     },
//     //     minHeight: "100vh",
//     //     p: 3,
//     //     gap: 3,
//     //     display: "flex",
//     //     flexDirection: "column",
//     //   }}
//     // >

//     <ParentWrapper>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <Box>
//           {/* <Typography
//             variant="h5"
//             sx={{
//               fontWeight: 500,
//               color: colorTheme('palette', 'secondary').value
//             }}
//           >
//             {"Interactions"}
//           </Typography>

//           <Typography variant="subtitle1" color="text.secondary">
//             Conversations and call recording uploaded on convoze plateform
//           </Typography> */}

//           {/* <Header title={"Interactions"} subHeading={" Conversations and call recording uploaded on convoze plateform"} /> */}
//         </Box>
//       </Box>

//       <Box>
//         {/* Search + Filters (always visible) */}
//         <Box
//           // sx={{
//           //   borderRadius: 2.5,
//           //   display: "flex",
//           //   justifyContent: "space-between",
//           // }}
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             // backgroundColor : "red",
//             flexDirection: { xs: "column", sm: "row" },
//             gap: 2,
//             "& > *": { width: { xs: "100%", lg: "50%" } },
//           }}
//         >
//           <SearchBar
//             value={searchInput}
//             onChange={(e) => {
//               setSearchInput(e.target.value);
//               setCurrentPage(1);
//             }}
//           />
// <Box
//   sx={{
//     display: "flex",
//     justifyContent : "flex-end",
//     gap: 2,
//     flexDirection: { xs: "column", sm: "row" },
//     // "& > *": { width: { xs: "100%", lg: "50%" } },
//   }}>
//             <CommonFilter
//               storageName="interactionFilter"
//               setPayloadData={setFilterPayload}
//               isFilter={isFilter}
//             />
// <Button
//   variant="contained"
//   color="primary"
//   sx={{ height: "37px", width: { xs: "100%", lg: "150px" }, backgroundColor: "#7635dd", borderRadius: "12px" }}
// onClick={handleExportExcel}
// >
//   Export Excel
// </Button>
//           </Box>
//         </Box>

//         {/* ---------- 1. loading ---------- */}
//         {/* {isLoading && (
//         <Box sx={{ height: 480, display: "flex", alignItems: "center", justifyContent: "center" }}>
//           <Loader />
//         </Box>
//       )} */}

//         {/* ---------- 2. empty ---------- */}
//         {/* {!isLoading && audioList?.length === 0 && (
//           <Box
//             sx={{
//               height: "80vh",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <NoData />
//           </Box>
//         )} */}
//         {isLoading ? (
//           <Loader />
//         ) : (
//           <>
//             {/* Table */}
//             <TableContainer
//               component={Paper}
//               sx={{
//                 // border: "1px solid #EEEEEE",
//                 border: `1px solid ${colorTheme("palette", "white").value}`,
//                 borderRadius: 2,
//                 overflowX: "auto",
//                 mt: 3,
//                 minHeight: "65vh",
//               }}
//             >
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     <TableHeading>Agent</TableHeading>
//                     <TableHeading>Customer</TableHeading>
//                     <TableHeading>Call Intent</TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Campaign
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Duration
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Direction
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Sentiment
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Compliance
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Created On
//                     </TableHeading>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {audioList?.length == 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <NoData />
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     audioList.map((row) => (
//                       <TableRow key={row?.id}>
//                         <AgentCell row={row} />
//                         <CustomerCell row={row} />
//                         <IntentCell intent={row?.callIntent} />
//                         <CampaignCell campaign={row?.campaignName} />
//                         <DurationCell duration={row?.callDuration} />
//                         <DirectionCell direction={row?.callDirection} />
//                         <SentimentCell sentiment={row?.overAllSentiment} />
//                         <ComplianceCell
//                           status={row?.complianceStatus}
//                           rating={row?.callAdherenceRating}
//                         />
//                         <DateCell date={row?.createdOn} />
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             {/* Pagination */}
//             <Stack
//               spacing={2}
//               sx={{ mt: 2, display: "flex", alignItems: "flex-end", p: 2 }}
//             >
//               <Typography variant="body2" color="text.secondary">
//                 {paginationInfo?.itemCount > 0
//                   ? `Showing ${(paginationInfo?.currentPage - 1) *
//                   paginationInfo?.perPage +
//                   1
//                   }-${Math.min(
//                     paginationInfo?.currentPage * paginationInfo?.perPage,
//                     paginationInfo?.itemCount
//                   )} of ${paginationInfo?.itemCount} results`
//                   : "No results found"}
//               </Typography>
//               <Pagination
//                 count={paginationInfo?.pageCount || 1}
//                 page={paginationInfo?.currentPage || 1}
//                 onChange={(e, v) => setCurrentPage(v)}
//                 sx={{
//                   "& .MuiPaginationItem-root": {
//                     color: colorTheme("palette", "primary").value,
//                     borderColor: colorTheme("palette", "primary").value,
//                   },
//                   "& .MuiPaginationItem-root.Mui-selected": {
//                     backgroundColor: `${colorTheme("palette", "primary").value
//                       }, !important`,
//                     color: `${colorTheme("palette", "night").value} !important`,
//                   },
//                   "& .MuiPaginationItem-root:hover": {
//                     backgroundColor: colorTheme("palette", "white").value,
//                   },
//                 }}
//               />
//             </Stack>
//           </>
//         )}
//       </Box>
//     </ParentWrapper>

//     // </Box>
//   );
// };

// export default AudioTable;


